<template>
  <div v-if="contactModel">
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h1 class="text-md-h1 primary--text mb-5">Admin Details</h1>
            <v-simple-table v-if="$route.params.id != 0">
              <tbody>
                <tr>
                  <td>First Name</td>
                  <td>
                    {{ contact.firstName ? contactModel.firstName : "" }}
                  </td>
                </tr>
                <tr>
                  <td>Last Name</td>
                  <td>
                    {{ contactModel.lastName }}
                  </td>
                </tr>
                <tr>
                  <td>Email</td>
                  <td>
                    {{ contactModel.email ? contactModel.email : "" }}
                  </td>
                </tr>
                <tr>
                  <td>Telephone Number</td>
                  <td>
                    {{ contactModel.telNumber ? contactModel.telNumber : "" }}
                  </td>
                </tr>
                <tr>
                  <td>Products that client already has with rebase</td>
                  <td>
                    {{
                      contactModel.existingProducts
                        ? contactModel.existingProducts
                        : "None-new client"
                    }}
                  </td>
                </tr>
                <tr>
                  <td>
                    Products Chosen During Registration That They Are Interested
                    In
                  </td>
                  <td>
                    {{
                      contactModel.productsInterestedIn.join(",")
                        ? contactModel.productsInterestedIn.join(",")
                        : ""
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Branch Name</td>
                  <td>
                    {{ contactModel.branchName ? contactModel.branchName : "" }}
                  </td>
                </tr>
                <!-- <tr>
                  <td>
                    Admin Name
                  </td>
                  <td>
                    {{
                      contactModel.consultantName ? contactModel.consultantName : ""
                    }}
                  </td>
                </tr> -->
                <tr>
                  <td>Branch ID</td>
                  <td>
                    {{ contactModel.branch ? contactModel.branch : "" }}
                  </td>
                </tr>

                <tr>
                  <td>FullAddress</td>
                  <td>
                    {{
                      contactModel.fullAddress ? contactModel.fullAddress : ""
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Admin ID</td>
                  <td>
                    {{ contactModel.consultant ? contactModel.consultant : "" }}
                  </td>
                </tr>
                <tr>
                  <td>Title</td>
                  <td>
                    {{ contactModel.title ? contactModel.title : "" }}
                  </td>
                </tr>
                <tr>
                  <td>Bio</td>
                  <td>
                    {{ contactModel.bio ? contactModel.bio : "" }}
                  </td>
                </tr>

                <tr>
                  <td>DOB</td>
                  <td>
                    {{ contactModel.dob ? contactModel.dob : "" }}
                  </td>
                </tr>
                <tr>
                  <td>Unique User ID</td>
                  <td>
                    {{ contactModel.id ? contactModel.id : "" }}
                  </td>
                </tr>
                <tr>
                  <td>Region</td>
                  <td>
                    {{ contactModel.region ? contactModel.region : "" }}
                  </td>
                </tr>
                <tr>
                  <td>Race</td>
                  <td>
                    {{ contactModel.race ? contactModel.race : "" }}
                  </td>
                </tr>
                <tr>
                  <td>Gender</td>
                  <td>
                    {{ contactModel.gender ? contactModel.gender : "" }}
                  </td>
                </tr>
                <tr>
                  <td>Postal Code</td>
                  <td>
                    {{ contactModel.postalCode ? contactModel.postalCode : "" }}
                  </td>
                </tr>
                <tr>
                  <td>Business Email</td>
                  <td>
                    {{
                      contactModel.businessEmail
                        ? contactModel.businessEmail
                        : ""
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Relationship Status</td>
                  <td>
                    {{
                      contactModel.relationship ? contactModel.relationship : ""
                    }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-col class="text-right">
              <v-btn
                v-if="$route.params.id == 0"
                color="primary"
                :to="`${$route.path}/edit`"
                class="mr-2"
                >Create a New User</v-btn
              >

              <v-btn
                v-else
                color="primary"
                :to="`${$route.path}/edit`"
                class="text-align-right"
                ><h1>Edit</h1>
              </v-btn>
            </v-col>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { User } from "@/models/User";
import { gql } from "apollo-boost";
export default {
  name: "AdminDetail",
  data() {
    return {
      isEdit: false,
      isLoading: false,
      contactModel: new User(),
      me: "",
      search: null,
      crumbs: [
        {
          text: "Admins",
          disabled: false,
          href: "/admin/admins",
        },
        {
          text: "Admin Details",
          disabled: true,
          href: `/admin/admins/${this.$route.params.id}`,
        },
      ],
    };
  },
  created() {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    contact: {
      query: gql`
        query User($id: ID!) {
          contact(id: $id) {
            id
            firstName
            lastName
            email
            telNumber
            existingProducts
            productsInterestedIn
            branch
            branchName
            consultant
            race
            dob
            title
            bio
            fullAddress
            gender
            title
            region
            postalCode
            businessEmail
            relationship
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.$route.params.id || this.$route.params.id == 0;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
        };
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading;
      },
      result(response, key) {
        this.isLoading = false;
        this.contactModel.id = this.contact.id;
        this.contactModel.firstName = this.contact.firstName;
        this.contactModel.lastName = this.contact.lastName;
        this.contactModel.email = this.contact.email;
        this.contactModel.telNumber = this.contact.telNumber;
        this.contactModel.existingProducts = this.contact.existingProducts;
        this.contactModel.productsInterestedIn =
          this.contact.productsInterestedIn;
        this.contactModel.branch = this.contact.branch;
        this.contactModel.branchName = this.contact.branchName;
        this.contactModel.fullAddress = this.contact.fullAddress;
        this.contactModel.consultant = this.contact.consultant;
        this.contactModel.title = this.contact.title;
        this.contactModel.bio = this.contact.bio;
        this.contactModel.dob = this.contact.dob;
        this.contactModel.region = this.contact.region;
        this.contactModel.race = this.contact.race;
        this.contactModel.gender = this.contact.gender;
        this.contactModel.postalCode = this.contact.postalCode;
        this.contactModel.businessEmail = this.contact.businessEmail;
        this.contactModel.relationship = this.contact.relationship;
        this.contactModel.dob = this.contact.dob;
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
